"use strict";

var React = require('react');

var compose = require('../hoc/compose');

var displayNames = require('./displayNames');

var RoundedIllustrationContainer = function RoundedIllustrationContainer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('rounded-illustration-container')
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-illustration-icon-content"
  }, props.children));
};

RoundedIllustrationContainer.propTypes = {};
RoundedIllustrationContainer.DisplayName = displayNames.ROUNDED_ILLUSTRATION_CONTAINER;
module.exports = compose(RoundedIllustrationContainer);